import scope from 'recompose-scope/composeWithScope'
import exposeProps from 'recompose-scope/exposeProps'

import withState from 'recompose/withState'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'

import View from './Filter'

function buildUrl (url, query) {
  if (!query) return url

  const queries = []
  Object.keys(query).forEach(key => {
    if (query[key] === undefined) return
    queries.push(`${key}=${encodeURIComponent(JSON.stringify(query[key]))}`)
  })

  return `${url}?${queries.join('&')}`
}


const SalesOrderDetail = scope(
  withState('query', 'setQuery', {}),

  withProps({
    fields: ['billDate'],
    schema: {
      type: 'object',
      contents: {
        billDate: {
          name: '結帳日期',
          type: 'Date',
          format: 'YYYY/MM/DD',
        },
      },
    },
  }),

  withHandlers({
    download: ({ query }) => () => {
      const url = buildUrl('api/print/salesOrder/xlsx', query)
      window.open(url, '_blank')
    },
    downloadToday: () => () => {
      window.open('api/print/salesOrder/xlsx', '_blank')
    },
  }),

  exposeProps([
    'query',
    'setQuery',
    'fields',
    'schema',

    'download',
    'downloadToday',
  ]),
)(View)

SalesOrderDetail.displayName = 'SalesOrderDetail'

export default SalesOrderDetail



// WEBPACK FOOTER //
// ./src/components/SalesOrderDetail/index.js